import $ from "jquery";
import Button from "components/button";
import growl from "utils/growl";
import i18n from "utils/i18n";
import PropTypes from "prop-types";
import React from "react";

/**
 * Renders the Subscribe/Unsubscribe button for managing the user's subscription to a mailing list.
 *
 * @example
 *   <MailingListSubscriptionButton email="me@example.com" isSubscribed={false} listId="news" />
 */
class MailingListSubscriptionButton extends React.Component {
  /**
   * Creates the component with the initial state based on props.
   *
   * @param {object} props Initial props
   */
  constructor(props) {
    super(props);
    this.state = { isSubscribed: props.isSubscribed };
    this.onSubscribe = this.onSubscribe.bind(this);
    this.onUnsubscribe = this.onUnsubscribe.bind(this);
  }

  /**
   * Performs the AJAX request for subscribing to the mailing list.
   *
   * @returns {Promise} Resolves without arguments
   */
  onSubscribe() {
    return new Promise(resolve => {
      $.ajax({
        data: { id: this.props.listId },
        type: "POST",
        url: i18n.path("mailing_list_subscriptions", { format: "json" })
      })
        .done(() => {
          growl.notice(i18n.t("plan.thank_you"));
          this.setState({ isSubscribed: true });
        })
        .always(() => resolve());
    });
  }

  /**
   * Performs the AJAX request for unsubscribing from the mailing list.
   *
   * @returns {Promise} Resolves without arguments
   */
  onUnsubscribe() {
    return new Promise(resolve => {
      $.ajax({
        data: { email: this.props.email },
        type: "DELETE",
        url: i18n.path("mailing_list_subscription", { format: "json", id: this.props.listId })
      })
        .done(() => {
          growl.notice(i18n.t("mailing_list.unsubscribe_heading"));
          this.setState({ isSubscribed: false });
        })
        .always(() => resolve());
    });
  }

  /**
   * Renders the button with "Subscribe" or "Unsubscribe" based on whether the user is subscribed to the list.
   *
   * @returns {object} The React element
   */
  render() {
    if (this.state.isSubscribed) {
      return (
        <Button className="btn btn-warning" onClick={this.onUnsubscribe} type="submit">
          <i className="fa fa-envelope" /> {i18n.t("global.unsubscribe")}
        </Button>
      );
    }

    return (
      <Button className="btn btn-primary" onClick={this.onSubscribe} type="submit">
        <i className="fa fa-envelope" /> {i18n.t("global.subscribe")}
      </Button>
    );
  }
}

MailingListSubscriptionButton.propTypes = {
  email: PropTypes.string.isRequired,
  isSubscribed: PropTypes.bool.isRequired,
  listId: PropTypes.string.isRequired
};

export default MailingListSubscriptionButton;
